"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react-hooks/exhaustive-deps */
const fp_1 = require("lodash/fp");
const react_1 = require("react");
exports.default = (fn, deps, millis) => (0, react_1.useMemo)(() => (0, fp_1.debounce)(millis, fn), [...deps, millis]);
